var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5618 8.52287L8.37587 2.54631C8.329 2.49223 8.27104 2.44886 8.20594 2.41913C8.14083 2.38941 8.0701 2.37402 7.99853 2.37402C7.92696 2.37402 7.85623 2.38941 7.79112 2.41913C7.72602 2.44886 7.66807 2.49223 7.62119 2.54631L2.43681 8.52287C2.42115 8.54089 2.41099 8.56302 2.40755 8.58665C2.40411 8.61027 2.40753 8.63439 2.41741 8.65612C2.42729 8.67786 2.44321 8.69629 2.46327 8.70923C2.48333 8.72218 2.50669 8.72908 2.53056 8.72912H3.79619C3.86806 8.72912 3.93681 8.69787 3.98525 8.64318L7.40556 4.701V13.4994C7.40556 13.5682 7.46181 13.6244 7.53056 13.6244H8.46806C8.53681 13.6244 8.59306 13.5682 8.59306 13.4994V4.701L12.0134 8.64318C12.0603 8.69787 12.129 8.72912 12.2024 8.72912H13.4681C13.5743 8.72912 13.6321 8.60412 13.5618 8.52287Z",
    fill: "#00875A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/ArrowUp2.276277d99e008568d7a7a7f8040631a5.svg";
export { ForwardRef as ReactComponent };